export default "e2eb5f23753026ac.png"